import LoginComponent from '../LoginComponent.vue'

export default [
    {
        path: '/',
        name: 'Login',
        meta: { layout: 'blank' },
        component: LoginComponent,
    },
]